import 'twin.macro'

import React, { FC } from 'react'
import tw, { TwStyle } from 'twin.macro'

type BodyTextProps = {
  children: React.ReactNode
  variant?: 'bold' | 'regular' | 'semibold'
  twStyle?: TwStyle
}
const textVariants = {
  bold: tw`font-bold tracking-normal`,
  regular: tw`font-normal`,
  semibold: tw`font-semibold`
} as { bold: TwStyle; regular: TwStyle; semibold: TwStyle }

const styles = {
  text: ({ variant = 'regular', twStyle }: { variant?: 'bold' | 'regular' | 'semibold'; twStyle?: TwStyle }) => [
    tw`text-s16 text-left`,
    textVariants[variant],
    twStyle
  ]
}

export const BodyText: FC<BodyTextProps> = ({ children, variant, twStyle }) => {
  return <span css={styles.text({ variant, twStyle })}>{children}</span>
}
export default BodyText
